import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    name: 'CHESS HOTEL',
    logo: require('@/assets/images/logos/logo.png'),
    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'default', // default, bordered, semi-dark
    contentWidth: 'boxed',
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#16b1ff',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#56CA00',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
      orange: '#F78D2C',
      teal: '#009688',
      purple: '#9C27B0',
      indigo: '#3F51B5',
    },
    dark: {
      primary: '#9155FD',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#56CA00',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
      orange: '#F78D2C',
      teal: '#009688',
      purple: '#9C27B0',
      indigo: '#3F51B5',
    },
  },
  bookingEngine: {
    heroStart: '#0d47a1',
    heroEnd: '#1e88e5',
    backgroundTop: '#e3f2fd',
    backgroundMid: '#f7f9fc',
    backgroundBottom: '#ffffff',
    cardStart: '#ffffff',
    cardEnd: '#e8f1ff',
    textPrimary: '#1f2a37',
    textSecondary: '#5d6473',
    outline: '#dce7f6',
    accent: '#ffb703',
    success: '#2E7D32',
    roomCardStart: '#ffffff',
    roomCardEnd: '#f9fbff',
  },
}

export default themeConfig
